import React, { useState, useEffect, useCallback, useMemo } from 'react';

export const DocumentFocusContext = React.createContext();

export const DocumentFocusProvider = ({ children }) => {
    const [focused, setFocused] = useState(document.hasFocus());

    const value = useMemo(() => {
        return { focused };
    }, [focused]);

    const handleBlur = useCallback(() => {
        setFocused(false);
    }, []);

    const handleFocus = useCallback(() => {
        setFocused(true);
    }, []);

    useEffect(() => {
        window.addEventListener('blur', handleBlur);
        window.addEventListener('focus', handleFocus);

        return () => {
            window.removeEventListener('blur', handleBlur);
            window.removeEventListener('focus', handleFocus);
        }
    }, []);

    return (
        <DocumentFocusContext.Provider value={value}>
            { children }
        </DocumentFocusContext.Provider>
    )
}
